export default __webpack_public_path__ + "static/media/dash-dice.9cc0b157.svg";